import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import Header from "../../components/Header.vue";
// import moment from "moment";
import SelectClient from "../../components/SelectClient.vue";
import SelectBL from "../../components/SelectBL.vue";
import {fetchYears} from "../../utils/fetchYears";
import YearComponent from "../../components/YearComponent.vue";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)


export default {
    components: {
        YearComponent,
        SelectBL, SelectClient,
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function() {
        return {
            pageTitle: "Liste des tresoreries",
            listYears: [],
            vuetable: {
                moreParams: {
                    filter: '',
                    date_debut: '',
                    date_fin: '',
                    criteriacol: '',
                },
                fields: [
                    {
                        name: 'ouverture_date_dossier_formatted',
                        title: 'Date Ouverture',
                        titleClass: 'text-left',
                        sortField: 'ouverture_date_dossier_formatted',
                        dataClass: 'text-left',
                        width: '150px'
                    },
                    {
                        name: 'nom_client',
                        title: 'Client',
                        titleClass: 'text-left',
                        sortField: 'nom_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'reference_article',
                        title: 'Référence',
                        sortField: 'reference_article',
                        dataClass: 'text-left'
                    },


                    {
                        name: 'designation_article',
                        title: 'Désignation',
                        sortField: 'designation_article',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'hs_code_article',
                        title: 'HS CODE',
                        sortField: 'hs_code_article',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'qte_article',
                        title: 'Quantité',
                        sortField: 'qte_article',
                        dataClass: 'text-right',
                        titleClass: 'text-right'
                    },
                    {
                        name: 'prix_fob',
                        title: 'Prix FOB',
                        sortField: 'prix_fob',
                        dataClass: 'text-right',
                        titleClass: 'text-right'
                    },
                    {
                        name: 'prix_cfr',
                        title: 'Prix CFR',
                        sortField: 'prix_cfr',
                        dataClass: 'text-right',
                        titleClass: 'text-right'
                    },
                    {
                        name: 'description_article',
                        title: 'Description',
                        sortField: 'description_article',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'remarque',
                        title: 'Remarque',
                        sortField: 'remarque',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'actions',
                        title: '-',
                        titleClass: 'text-center column_fixed-header',
                        width: "80px",
                        dataClass: "text-center column_fixed"
                    }

                ],
                sortOrder: [
                    { field: 'ouverture_date_dossier', direction: 'desc' }
                ],
                css: {
                    table: {
                        // tableClass: 'table table-striped table-bordered table-hovered',
                        tableClass: 'table-responsive text-nowrap w-100 d-block d-md-table table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'fas fa-arrow-up fa-sm',
                        descendingIcon: 'fas fa-arrow-down fa-sm',
                        handleIcon: 'fas fa-bars fa-sm',
                    },
                    pagination: {
                        infoClass: 'pull-left ',
                        wrapperClass: 'vuetable-pagination text-center',
                        activeClass: 'btn-secondary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        },
                    }
                },
            },
            exportexcel: {
                json_fields: {
                    'Nom de la Tresorerie': 'reference_article',
                    'Type de la Tresorerie': 'type_tresorerie',
                    'Solde': 'solde',
                    'Nom du compte': 'nom_compte',
                    'Numero du compte': 'numero_compte',
                    'BIC': 'bic',
                    'IBAN': 'iban',
                    'BANQUE Correspondante': 'banque_correspondante',
                    'Code swift': 'code_swift',
                    'Utilisateur associé': 'nom'

                },
                json_data: [],
                json_meta: [
                    [{
                        'key': 'charset',
                        'value': 'utf-8'
                    }]
                ],
            },
            motCle: "",
            filtre: {
                filter: '',
                date_debut: '',
                date_fin: '',
                year: '',
            },
            criteriacol: '',
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            crudform: {
                id: "",
                reference_article: "",
                designation_article: "",
                hs_code_article: "",
                description_article: "",
                prix_fob: '',
                prix_cfr: '',
            },
            crudmodaltitle: "Nouveau Article",

            crudFranchise:[{
                id:'',
                id_compagnie:'',
                ordre:'',
                libeller_franchise:'',
                nbre_jour:0,
                reference_article:'',
                tarif:0,
            }],
            btn_submit:false,
        }
    },
    methods: {



        onRowClass(dataItem, index) {
            if (index == "") console.log("");

            if(Number(dataItem.solde) < 0) {
                // return 'text-danger text-bold';
            }
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        editRow(rowData) {
            //alert("You clicked edit on" + JSON.stringify(rowData))
            axios.get(this.BASE_URL + "/article/get/" + rowData.id).then(response => {
                this.crudform = response.data[0];
            });
            this.crudmodaltitle = "Editer une Article";
            this.openModal();
        },
        deleteRow(rowData) {
            //alert("You clicked delete on" + JSON.stringify(rowData));
            var that = this;
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        axios.post(that.BASE_URL + "/article/delete/" + rowData.id).then(function(response) {
                            console.log(response);
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log(response.data.message);
                                that.setFilter();
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })

        },
        onLoading() {
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },
        setFilter() {
            this.vuetable.moreParams = {
                filter: this.filtre.filter,
                date_debut: this.filtre.date_debut,
                date_fin: this.filtre.date_fin,
                criteriacol: this.criteriacol,
                year: this.filtre.year,
            }
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        resetFilter() {

            this.vuetable.moreParams = {
                filter: '',
                date_debut: '',
                date_fin: '',
                criteriacol: '',
                year: '',
            }
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onExport() {

            this.exportexcel.json_data = this.$refs.vuetable.$data.tableData;
            $("#excel-download").trigger("click");
        },
        openModal() {
            this.fetchData();
            this.$bvModal.show("crudmodal");
        },
        closeModal() {
            this.$bvModal.hide("crudmodal");
        },
        addRow() {
            this.crudmodaltitle = "Nouveau Article";
            this.crudform = {
                id: "",
                reference_article: "",
                designation_article: "",
                hs_code_article: "",
                description_article: "",
                prix_fob: '',
                prix_cfr: '',
            };
            // console.log(this.crudform);
            this.openModal();
        },
        onSubmit() {
            var that = this;

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment continuer l\'enregistrement?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Continuer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        var link = '';
                        that.btn_submit = true;

                        link = that.crudform.id == '' ? that.BASE_URL + "/article/addaction" : that.BASE_URL + "/article/editaction";

                        axios.post(link, $("#formulaire").serialize()).then(function(response) {
                            console.log(response);
                            that.btn_submit = false;
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log("Enregistrement effectué avec succès!");
                                that.closeModal();
                                that.setFilter();
                                Vue.$toast.open({
                                    message: 'Enregistrement effectué avec succès!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                });
        },
        fetchData: function() {
            axios.get(this.BASE_URL + "/tresoreries/fetchdata").then(response => {
                console.log(response)
                this.listdata = response.data;
            });
        },
        async fetchYear() {
            const response = await fetchYears({that: this, link: '/dossier/fetchyear'})
            this.listYears = response.data;
        },
        selectYear(year){
            this.filtre.year = year;
            this.setFilter();
        }
    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        this.motCle = "";
        this.criteriacol = "";

    },
    mounted: async function() {
        await this.fetchYear();
    }
}
